import { namespaceActionObject } from './helpers';
import { Map } from 'immutable';
import { isVirtualOnboarding } from './currentProgressOnboardingWizard';
import { takeEvery, put, call, select, all } from 'redux-saga/effects';
import { getttingDealInfo, getttingDealInfoVirtual } from '../services/backendService';
import { getAuthToken } from './auth';
import * as tracking from '../tracking/tracking';

// TYPES

export const REDUCER_ACTIONS = namespaceActionObject('DEAL')({
  SEND_DEAL_INFO: 'SEND_DEAL_INFO',
  DEAL_INFO_FETCH_PENDING: 'DEAL_INFO_FETCH_PENDING',
  DEAL_INFO_FETCH_SUCCESS: 'DEAL_INFO_FETCH_SUCCESS',
  DEAL_INFO_FETCH_ERROR: 'DEAL_INFO_FETCH_ERROR'
});

export const REDUCER_STATUS = {
  DEAL_INFO_NOT_ASK: 'DEAL_INFO_NOT_ASK',
  DEAL_INFO_ASK: 'DEAL_INFO_ASK',
  DEAL_INFO_SENT: 'DEAL_INFO_SENT',
  DEAL_INFO_ERROR: 'DEAL_INFO_ERROR',
  DEAL_INFO_FETCH_SUCCESS: 'DEAL_INFO_FETCH_SUCCESS'
};

// ACTIONS

export const sendDealInfo = dealInfo => ({
  type: REDUCER_ACTIONS.SEND_DEAL_INFO,
  payload: dealInfo
});

export const dealInfoFetchPending = () => ({
  type: REDUCER_ACTIONS.DEAL_INFO_FETCH_PENDING
});

export const dealInfoFetchSuccess = dealInfo => {
  return {
    type: REDUCER_ACTIONS.DEAL_INFO_FETCH_SUCCESS,
    payload: dealInfo
  };
};

export const dealInfoFetchError = error => ({
  type: REDUCER_ACTIONS.DEAL_INFO_FETCH_ERROR,
  payload: error
});

// SAGAS

export function* watchGetFetchDealInfo() {
  yield takeEvery(REDUCER_ACTIONS.SEND_DEAL_INFO, fetchingDealInfo);
}

export function* fetchingDealInfo(action) {
  try {
    yield put(dealInfoFetchPending());
    const jwtToken = yield select(getAuthToken);
    const isVirtualFlow = yield select(isVirtualOnboarding);
    if (isVirtualFlow) {
      const dealInfo = yield call(getttingDealInfoVirtual, action.payload, jwtToken);
      yield put(dealInfoFetchSuccess(dealInfo.data));
    } else {
      const dealInfo = yield call(getttingDealInfo, action.payload, jwtToken);
      const { startDate, endDate, mikdama, rent, helka, gush, streetName, address, floor, apartmentNumber } = dealInfo.data;
      yield put(dealInfoFetchSuccess(dealInfo.data));
      yield all([
        call(tracking.addContractInformationToIntercom, dealInfo),
        call(tracking.updateCustomUserProperties, {
          contractStartDate: startDate,
          contractEndDate: endDate,
          mikdama,
          rent,
          helka,
          gush,
          streetName,
          address,
          floor,
          apartmentNumber
        })
      ]);
    }
  } catch (error) {
    yield put(dealInfoFetchError(error));
    console.warn('Failed deal info fetch', error);
  }
}

// STATE MAPPERS
export const getDealInfo = state => state.DealInfo.get('data');
export const didDealInfoFailed = state => state.DealInfo.get('status') === REDUCER_STATUS.DEAL_INFO_FETCH_ERROR;
export const isDealInfoPending = state => state.DealInfo.get('status') === REDUCER_STATUS.DEAL_INFO_FETCH_PENDING;
export const isDealInfoLoaded = state => state.DealInfo.get('status') === REDUCER_STATUS.DEAL_INFO_FETCH_SUCCESS;
export const getMemberShipPlan = state => state.DealInfo.get('data').get('membershipPlan');
export const getMemberShipPlanPeriod = state => state.DealInfo.get('data').get('planPeriod');
const initState = Map({
  status: REDUCER_STATUS.DEAL_INFO_NOT_ASK
});

export default (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case REDUCER_ACTIONS.DEAL_INFO_FETCH_PENDING:
      return state.set('status', REDUCER_STATUS.DEAL_INFO_FETCH_PENDING);
    case REDUCER_ACTIONS.DEAL_INFO_FETCH_SUCCESS:
      return state.merge({ status: REDUCER_STATUS.DEAL_INFO_FETCH_SUCCESS, data: payload });
    case REDUCER_ACTIONS.DEAL_INFO_FETCH_ERROR:
      return state.merge({ status: REDUCER_STATUS.DEAL_INFO_ERROR, error: payload });
    case REDUCER_ACTIONS.SEND_DEAL_INFO:
      return state.set('dealInfo', payload);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/DealInfo.js